// Mock data for Smart Asset Tracking System - Warehouse Transfer Model

export const ASSET_TYPES = {
  FLC: 'Foldable Large Container',
  PSS: 'Pallet Sleeve System',
  WMC: 'Wire Mesh Container'
};

// Leadec Warehouse Locations
export const WAREHOUSES = {
  PUNE: { name: 'Pune', lat: 18.5204, lng: 73.8567, code: 'PUN' },
  BANGALORE: { name: 'Bangalore', lat: 12.9716, lng: 77.5946, code: 'BLR' },
  CHENNAI: { name: 'Chennai', lat: 13.0827, lng: 80.2707, code: 'CHN' },
  GURGAON: { name: 'Gurgaon', lat: 28.4595, lng: 77.0266, code: 'GGN' },
  AHMEDABAD: { name: 'Ahmedabad', lat: 23.0225, lng: 72.5714, code: 'AMD' }
};

// Leadec Customers
export const CUSTOMERS = {
  TATA: { name: 'Tata Motors', id: 'CUST-001', location: 'Pune', assetTypes: ['FLC', 'WMC'] },
  VOLKSWAGEN: { name: 'Volkswagen', id: 'CUST-002', location: 'Pune', assetTypes: ['PSS', 'FLC'] },
  FIAT: { name: 'Fiat', id: 'CUST-003', location: 'Pune', assetTypes: ['WMC'] },
  HYUNDAI: { name: 'Hyundai', id: 'CUST-004', location: 'Chennai', assetTypes: ['FLC', 'PSS'] },
  MARUTI: { name: 'Maruti Suzuki', id: 'CUST-005', location: 'Gurgaon', assetTypes: ['FLC', 'WMC', 'PSS'] }
};

// Transportation Routes with costs
export const ROUTES = [
  { id: 'R001', from: 'Pune', to: 'Bangalore', distance: 840, costPerTrip: 12500, avgDays: 2 },
  { id: 'R002', from: 'Bangalore', to: 'Chennai', distance: 350, costPerTrip: 6800, avgDays: 1 },
  { id: 'R003', from: 'Chennai', to: 'Pune', distance: 1100, costPerTrip: 15200, avgDays: 3 },
  { id: 'R004', from: 'Pune', to: 'Gurgaon', distance: 1450, costPerTrip: 18500, avgDays: 3 },
  { id: 'R005', from: 'Gurgaon', to: 'Ahmedabad', distance: 950, costPerTrip: 13800, avgDays: 2 },
  { id: 'R006', from: 'Ahmedabad', to: 'Pune', distance: 670, costPerTrip: 10200, avgDays: 2 }
];

export const ASSET_STATUS = {
  IN_TRANSIT: 'In Transit',
  AT_WAREHOUSE: 'At Warehouse',
  AT_CUSTOMER: 'At Customer',
  LOADING: 'Loading',
  UNLOADING: 'Unloading',
  MAINTENANCE: 'Maintenance'
};

export const ALERT_TYPES = {
  AGING: 'Aging Threshold Exceeded',
  INVENTORY_HIGH: 'Inventory Too High',
  INVENTORY_LOW: 'Inventory Too Low',
  DELAYED: 'Delayed Return',
  MAINTENANCE: 'Maintenance Required'
};

export const ALERT_SEVERITY = {
  CRITICAL: 'Critical',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low'
};

// Aging thresholds (in days)
export const AGING_THRESHOLDS = {
  FLC: 7,  // 7 days max at warehouse
  PSS: 5,  // 5 days max at warehouse
  WMC: 10  // 10 days max at warehouse
};

// Helper function to calculate days between dates
const daysBetween = (date1, date2) => {
  const diff = Math.abs(new Date(date2) - new Date(date1));
  return Math.floor(diff / (1000 * 60 * 60 * 24));
};

// Asset Transfer History - tracks warehouse in/out movements
// Each asset has multiple transfer records showing movement between warehouses
export const MOCK_ASSETS = [
  {
    id: 'FLC-001',
    type: 'FLC',
    name: 'FLC Container 001',
    status: 'AT_WAREHOUSE',
    currentWarehouse: 'Pune',
    currentCustomer: null,
    originWarehouse: 'Pune',
    transferHistory: [
      { warehouse: 'Pune', transferIn: '2025-12-10T08:00:00Z', transferOut: '2025-12-12T14:00:00Z', ageDays: 2 },
      { warehouse: 'Bangalore', transferIn: '2025-12-13T10:00:00Z', transferOut: '2025-12-15T16:00:00Z', ageDays: 2 },
      { warehouse: 'Chennai', transferIn: '2025-12-16T09:00:00Z', transferOut: null, ageDays: 1 }
    ],
    lastCycleTime: 14, // days to return to origin
    totalTrips: 145
  },
  {
    id: 'FLC-002',
    type: 'FLC',
    name: 'FLC Container 002',
    status: 'AT_CUSTOMER',
    currentWarehouse: null,
    currentCustomer: 'Tata Motors',
    originWarehouse: 'Pune',
    transferHistory: [
      { warehouse: 'Pune', transferIn: '2025-12-05T07:00:00Z', transferOut: '2025-12-08T11:00:00Z', ageDays: 3 },
      { warehouse: 'Gurgaon', transferIn: '2025-12-11T15:00:00Z', transferOut: '2025-12-14T10:00:00Z', ageDays: 3 },
      { warehouse: 'Pune', transferIn: '2025-12-17T08:00:00Z', transferOut: null, ageDays: 0 }
    ],
    lastCycleTime: 23, // days
    totalTrips: 89
  },
  {
    id: 'PSS-001',
    type: 'PSS',
    name: 'PSS Container 001',
    status: 'AT_WAREHOUSE',
    currentWarehouse: 'Chennai',
    currentCustomer: null,
    originWarehouse: 'Bangalore',
    transferHistory: [
      { warehouse: 'Bangalore', transferIn: '2025-12-01T06:00:00Z', transferOut: '2025-12-03T12:00:00Z', ageDays: 2 },
      { warehouse: 'Chennai', transferIn: '2025-12-11T14:00:00Z', transferOut: null, ageDays: 7 }
    ],
    lastCycleTime: 18, // days
    totalTrips: 234
  },
  {
    id: 'PSS-002',
    type: 'PSS',
    name: 'PSS Container 002',
    status: 'AT_WAREHOUSE',
    currentWarehouse: 'Chennai',
    currentCustomer: null,
    originWarehouse: 'Pune',
    transferHistory: [
      { warehouse: 'Pune', transferIn: '2025-12-01T08:00:00Z', transferOut: '2025-12-03T14:00:00Z', ageDays: 2 },
      { warehouse: 'Bangalore', transferIn: '2025-12-04T10:00:00Z', transferOut: '2025-12-06T16:00:00Z', ageDays: 2 },
      { warehouse: 'Chennai', transferIn: '2025-12-10T09:00:00Z', transferOut: null, ageDays: 8 }
    ],
    lastCycleTime: 17, // days
    totalTrips: 67
  },
  {
    id: 'WMC-001',
    type: 'WMC',
    name: 'WMC Container 001',
    status: 'AT_WAREHOUSE',
    currentWarehouse: 'Ahmedabad',
    currentCustomer: null,
    originWarehouse: 'Pune',
    transferHistory: [
      { warehouse: 'Pune', transferIn: '2025-12-03T07:00:00Z', transferOut: '2025-12-06T11:00:00Z', ageDays: 3 },
      { warehouse: 'Gurgaon', transferIn: '2025-12-09T15:00:00Z', transferOut: '2025-12-11T10:00:00Z', ageDays: 2 },
      { warehouse: 'Ahmedabad', transferIn: '2025-12-13T08:00:00Z', transferOut: null, ageDays: 4 }
    ],
    lastCycleTime: 21, // days
    totalTrips: 178
  },
  {
    id: 'WMC-002',
    type: 'WMC',
    name: 'WMC Container 002',
    status: 'AT_WAREHOUSE',
    currentWarehouse: 'Pune',
    currentCustomer: null,
    originWarehouse: 'Pune',
    transferHistory: [
      { warehouse: 'Pune', transferIn: '2025-12-13T08:00:00Z', transferOut: null, ageDays: 5 }
    ],
    lastCycleTime: 0, // Still at origin
    totalTrips: 45
  },
  {
    id: 'FLC-003',
    type: 'FLC',
    name: 'FLC Container 003',
    status: 'AT_WAREHOUSE',
    currentWarehouse: 'Bangalore',
    currentCustomer: null,
    originWarehouse: 'Bangalore',
    transferHistory: [
      { warehouse: 'Bangalore', transferIn: '2025-12-12T08:00:00Z', transferOut: null, ageDays: 5 }
    ],
    lastCycleTime: 0,
    totalTrips: 201
  },
  {
    id: 'FLC-004',
    type: 'FLC',
    name: 'FLC Container 004',
    status: 'AT_WAREHOUSE',
    currentWarehouse: 'Chennai',
    currentCustomer: null,
    originWarehouse: 'Chennai',
    transferHistory: [
      { warehouse: 'Chennai', transferIn: '2025-12-14T08:00:00Z', transferOut: null, ageDays: 3 }
    ],
    lastCycleTime: 0,
    totalTrips: 123
  },
  {
    id: 'PSS-003',
    type: 'PSS',
    name: 'PSS Container 003',
    status: 'AT_WAREHOUSE',
    currentWarehouse: 'Gurgaon',
    currentCustomer: null,
    originWarehouse: 'Gurgaon',
    transferHistory: [
      { warehouse: 'Gurgaon', transferIn: '2025-12-15T08:00:00Z', transferOut: null, ageDays: 3 }
    ],
    lastCycleTime: 0,
    totalTrips: 189
  },
  {
    id: 'WMC-003',
    type: 'WMC',
    name: 'WMC Container 003',
    status: 'AT_WAREHOUSE',
    currentWarehouse: 'Pune',
    currentCustomer: null,
    originWarehouse: 'Pune',
    transferHistory: [
      { warehouse: 'Pune', transferIn: '2025-12-10T08:00:00Z', transferOut: null, ageDays: 8 }
    ],
    lastCycleTime: 0,
    totalTrips: 156
  }
];

// Calculate current aging for assets at warehouses
MOCK_ASSETS.forEach(asset => {
  if (asset.status === 'AT_WAREHOUSE' && asset.transferHistory.length > 0) {
    const lastTransfer = asset.transferHistory[asset.transferHistory.length - 1];
    if (!lastTransfer.transferOut) {
      const ageDays = daysBetween(lastTransfer.transferIn, new Date());
      lastTransfer.ageDays = ageDays;
      asset.currentAgeDays = ageDays;
      asset.exceedsThreshold = ageDays > AGING_THRESHOLDS[asset.type];
    }
  }
});

// Alerts for aging violations and battery
export const MOCK_ALERTS = [
  {
    id: 'ALT-001',
    type: 'AGING',
    severity: 'CRITICAL',
    warehouse: 'Chennai',
    assetId: 'PSS-001',
    assetName: 'PSS Container 001',
    message: 'Asset aging exceeds threshold at Chennai warehouse',
    ageDays: 7,
    threshold: 5,
    timestamp: new Date(Date.now() - 2 * 3600000).toISOString(),
    acknowledged: false
  },
  {
    id: 'ALT-002',
    type: 'AGING',
    severity: 'CRITICAL',
    warehouse: 'Chennai',
    assetId: 'PSS-002',
    assetName: 'PSS Container 002',
    message: 'Asset aging exceeds threshold at Chennai warehouse',
    ageDays: 8,
    threshold: 5,
    timestamp: new Date(Date.now() - 3 * 3600000).toISOString(),
    acknowledged: false
  },
  {
    id: 'ALT-003',
    type: 'BATTERY',
    severity: 'HIGH',
    warehouse: 'Pune',
    assetId: 'WMC-003',
    assetName: 'WMC Container 003',
    message: 'Battery charge is less than 35% at Pune warehouse',
    batteryLevel: 28,
    threshold: 35,
    timestamp: new Date(Date.now() - 1 * 3600000).toISOString(),
    acknowledged: false
  }
];

// Dashboard Statistics
export const DASHBOARD_STATS = {
  totalAssets: 6250,
  totalAssetsThisMonth: 50,
  assetsInTransit: 3750,
  assetsLoading: 812,
  idleAssets: 1375,
  maintenanceAssets: 313,
  activeAlerts: 3,
  criticalAlerts: 2,
  averageUtilization: 73,
  totalMovementsToday: 4375,
  totalMovementsMonth: 8456
};

// Weekly Cycle Time Report
export const CYCLE_TIME_REPORT = [
  { assetType: 'FLC', assetId: 'FLC-001', cycleTimeDays: 14, originWarehouse: 'Pune' },
  { assetType: 'FLC', assetId: 'FLC-002', cycleTimeDays: 23, originWarehouse: 'Pune' },
  { assetType: 'PSS', assetId: 'PSS-002', cycleTimeDays: 34, originWarehouse: 'Pune' },
  { assetType: 'PSS', assetId: 'PSS-001', cycleTimeDays: 18, originWarehouse: 'Bangalore' },
  { assetType: 'WMC', assetId: 'WMC-001', cycleTimeDays: 21, originWarehouse: 'Pune' }
];

// Inventory by Warehouse
export const WAREHOUSE_INVENTORY = {
  Pune: { FLC: 850, PSS: 420, WMC: 680, total: 1950 },
  Bangalore: { FLC: 620, PSS: 380, WMC: 450, total: 1450 },
  Chennai: { FLC: 540, PSS: 320, WMC: 390, total: 1250 },
  Gurgaon: { FLC: 480, PSS: 250, WMC: 320, total: 1050 },
  Ahmedabad: { FLC: 380, PSS: 180, WMC: 290, total: 850 },
  Mumbai: { FLC: 280, PSS: 150, WMC: 270, total: 700 }
};

// Transportation Cost Data (Daily)
export const DAILY_TRANSPORT_COSTS = [
  { date: '2025-12-17', route: 'Pune -> Bangalore', trips: 8, cost: 100000 },
  { date: '2025-12-17', route: 'Bangalore -> Chennai', trips: 12, cost: 81600 },
  { date: '2025-12-17', route: 'Chennai -> Pune', trips: 6, cost: 91200 },
  { date: '2025-12-17', route: 'Pune -> Gurgaon', trips: 5, cost: 92500 },
  { date: '2025-12-17', route: 'Gurgaon -> Ahmedabad', trips: 4, cost: 55200 },
  { date: '2025-12-17', route: 'Ahmedabad -> Pune', trips: 7, cost: 71400 }
];

// Monthly Transportation Cost Summary
export const MONTHLY_TRANSPORT_COSTS = [
  { route: 'Pune -> Bangalore', trips: 245, totalCost: 3062500, avgCostPerTrip: 12500 },
  { route: 'Bangalore -> Chennai', trips: 380, totalCost: 2584000, avgCostPerTrip: 6800 },
  { route: 'Chennai -> Pune', trips: 195, totalCost: 2964000, avgCostPerTrip: 15200 },
  { route: 'Pune -> Gurgaon', trips: 156, totalCost: 2886000, avgCostPerTrip: 18500 },
  { route: 'Gurgaon -> Ahmedabad', trips: 128, totalCost: 1766400, avgCostPerTrip: 13800 },
  { route: 'Ahmedabad -> Pune', trips: 218, totalCost: 2223600, avgCostPerTrip: 10200 }
];

export const MOCK_REPORTS = {
  utilizationByType: [
    { type: 'FLC', count: 2550, utilization: 74, inTransit: 1530, loading: 332, idle: 561, maintenance: 127 },
    { type: 'WMC', count: 1400, utilization: 75, inTransit: 840, loading: 182, idle: 308, maintenance: 70 },
    { type: 'PSS', count: 2300, utilization: 71, inTransit: 1380, loading: 298, idle: 506, maintenance: 116 }
  ]
};

